var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHouseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8045 7.52877L8.47121 0.195435C8.21088 -0.0648195 7.78888 -0.0648195 7.52854 0.195435L0.19521 7.52877C0.00460517 7.71943 -0.0524042 8.00613 0.0507585 8.25521C0.153921 8.50428 0.396947 8.66671 0.666544 8.66677H1.49988C1.59192 8.66677 1.66654 8.74139 1.66654 8.83344V15.3334C1.66654 15.7016 1.96502 16.0001 2.33321 16.0001H6.16654C6.25859 16.0001 6.33321 15.9255 6.33321 15.8334V12.6668C6.33321 11.7463 7.0794 11.0001 7.99988 11.0001C8.92035 11.0001 9.66654 11.7463 9.66654 12.6668V15.8334C9.66654 15.9255 9.74116 16.0001 9.83321 16.0001H13.6665C14.0347 16.0001 14.3332 15.7016 14.3332 15.3334V8.83344C14.3332 8.74139 14.4078 8.66677 14.4999 8.66677H15.3332C15.6028 8.66671 15.8458 8.50428 15.949 8.25521C16.0522 8.00613 15.9951 7.71943 15.8045 7.52877Z",
    fill: "#242424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseIcon);
export default __webpack_public_path__ + "static/media/house-icon.fbbe56f153180a02efc24e61eb9f972f.svg";
export { ForwardRef as ReactComponent };